import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-057b5992"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-sale-details" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rules", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" This after-sale is provided by   ")
const _hoisted_4 = { class: "apple" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  store ")
const _hoisted_6 = { class: "after-details-main" }
const _hoisted_7 = { class: "step-box" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Apply")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Processing")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Complete")
const _hoisted_11 = { class: "after-details-conent" }
const _hoisted_12 = { class: "after-state" }
const _hoisted_13 = { class: "after-state-l" }
const _hoisted_14 = {
  key: 0,
  class: "after-time"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Ends in", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_17 = { class: "avatar-title" }
const _hoisted_18 = {
  key: 2,
  class: "img-box"
}
const _hoisted_19 = { class: "img-content" }
const _hoisted_20 = { class: "after-details-bottom" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-title" }, "Return Tracking", -1))
const _hoisted_22 = { class: "msg" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = { class: "btn" }

import { ref, inject } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Header from '@/components/header/header.vue'
import DetailCardNew from './component/afterDetailsCardNew.vue'
import BottomBtn from './component/afterBottomBtn.vue'
import KiliButton from '@/components/KiliButton.vue'
import { linkChat, getFilePath, getRuleUrl } from '@/hooks/index'
import { Toast } from 'vant'

export default /*#__PURE__*/_defineComponent({
  __name: 'afterSaleDetailsNew',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const $http: any = inject('$http')
const $store: any = inject('$store')
let btnData = ref([
]) as any
/** detailCardData 详情卡片模块数据说明
 * title:'' 当前详情模块标题
 * textData:[]  当前模块文字数据
 * fileList: [], 当前模块图片视频数据
 * transit: {}, // 当前模块物流信息数据
 */
let detailCardData: any = ref([])
let topData = ref({
  active: 0,
  afterSaleStatus: '',
  time: 0,
  textData: [],
  fileList: []
})
// 详情页按钮是否可操作
let btnJurisdictionObj = ref({
  isAvailable: false, // 是否显示申诉按钮
  isEditAddress: false // 是否可编辑发货地址
})
let showDialog = ref(false)
let popupValue = ref('')
let pageTitle = ref('')
let logisticsData = ref({})
let waybill = ref([])
let skipPath = ref('/afterSale')
let formParam = ref({})
// 售后详情id/审核单id
let detailsId = ref({
  checkId: 0,
  storeId: ''
})
let loading = ref(false) // 弹窗的 继续按钮 loading
let storeName = ref('') // 店铺名称
let ruleUrl = ref('')
let imgPathData = {}
const handleBtn = async (item: any) => {
  if (item.title === 'Contact Seller') {
    linkChat($http, $store, detailsId.value.storeId)
  } else {
    if (item.status == 4) {
      // 取消售后
      popupValue.value =
        'Please confirm whether to cancel the after-sales service order.'
      showDialog.value = true
    } else if (item.status == 1) {
      // 确认的弹窗文案有两种 I: available_type为4时为确认收货, II: available_type为1或6时时为确认方案
      if (item.available_type == 4) {
        popupValue.value =
          'Please confirm whether the goods has been received.'
        showDialog.value = true
      } else if (item.available_type == 1 || item.available_type == 6) {
        popupValue.value =
          'Do you agree with the solution given by the seller？'
        showDialog.value = true
      } else if (item.available_type == 5) {
        router.push({
          name: 'afterSaleExpress',
          params: {
            isDetail: 1,
            name: `${route.query.name}`
          }
        })
      }
    } else if (item.status == 3) {
      appeal()
    } else {
      router.push({
        path: `/afterSaleEvaluation/${route.params.id}?store_id=${detailsId.value.storeId}`
      })
    }
    formParam.value = {
      check_id: detailsId.value.checkId,
      check_status: item.status
    }
  }
}
const goToRule = () => {
  if (ruleUrl.value) {
    window.open(ruleUrl.value)
  }
}
const appeal = () => {
  router.push(
    `/afterSaleComplaint/${route.params.id}?check_id=${detailsId.value.checkId}&name=${route.query.name}`
  )
}
const jumpShop = () => {
  //店铺跳转
  router.push({
    name: 'shop',
    params: {
      id: detailsId.value.storeId
    }
  })
}
// 操作联系商家
const handleContact = async () => {
  linkChat($http, $store, detailsId.value.storeId)
  showDialog.value = false
}

const handleContinue = async () => {
  showDialog.value = false
  // 确认或取消
  loading.value = true
  const res1: any = await $http.setAfterSaleExpressWay(formParam.value)
  if (res1.code === 200) {
    //   取消或确认后，前往列表页面
    router.push('/afterSale?name=state_all')
  } else {
    Toast(res1.msg)
  }
  loading.value = false
}

const clickLogInfo = () => {
  router.push(`/afterSaleLogInfo/${route.params.id}`)
}
const dateFormat = (i: any) => {
  return (
    new Date(i).toDateString().split(' ')[1] +
    ' ' +
    new Date(i).getDate() +
    ',' +
    new Date(i).getFullYear() +
    ' at ' +
    (new Date(i).getHours() <= 9
      ? '0' + new Date(i).getHours()
      : new Date(i).getHours()) +
    ':' +
    (new Date(i).getMinutes() <= 9
      ? '0' + new Date(i).getMinutes()
      : new Date(i).getMinutes())
  )
}
// 获取并处理详情数据
const getAfterSaleDetail = async () => {
  skipPath.value = `/afterSale?name=${route.query.name}`
  getRuleUrl().then((res: any) => {
    const { aftersale_rules } = res.agreements
    ruleUrl.value = aftersale_rules.display
      ? res.agreements.aftersale_rules.url
      : ''
  })
  let id = route.params.id
  const filePathRes: any = await getFilePath() // 获取视频/图片拼接路径及格式
  if (filePathRes) {
    imgPathData = filePathRes
  }
  const res: any = await $http.getAfterSaleDetail({ id: id })
  if (res.code !== 200) {
    return Toast(res.msg)
  }
  const DETAIL = JSON.parse(JSON.stringify(res.data))
  let applyInfo = DETAIL.extra.common_info.apply_info // 用户申请售后的信息
  let exchangeInfo = DETAIL.exchange_goods_info // 用户申请售后的信息
  $store.setAfterId({
    afterId: DETAIL.id,
    checkId: DETAIL.available_check_id
  })
  const actions = DETAIL.actions
  btnJurisdictionObj.value.isEditAddress =
    DETAIL.available_type && DETAIL.available_action.indexOf(7) != -1
  topData.value = {
    active: DETAIL.status == 0 ? 3 : DETAIL.status - 1, // 售后主状态:0-取消;1-审核中;2-执行中;3-完成，会用到的是1-3的状态,所以需要减1 注：当为 0 时表示取消，进度条则是到已完成，故active为3
    afterSaleStatus: DETAIL.title_action.content.title.title_en,
    time: DETAIL.countdown,
    textData: DETAIL.title_action.content.values,
    fileList: DETAIL.title_action.attachments
  }
  detailsId.value = {
    checkId: DETAIL.available_check_id,
    storeId: DETAIL.store_id
  }
  storeName.value = DETAIL.store_name
  const isExchange =
    applyInfo.exchange_goods_info &&
    !Array.isArray(applyInfo.exchange_goods_info) &&
    applyInfo.exchange_goods_info.id
  btnJurisdictionObj.value.isAvailable = DETAIL.available_action.some(
    (item: any) => item == 3
  )
  const applicationData = {
    title: 'Aftersale Application',
    status: 'goods',
    goodsData: DETAIL.order_goods,
    showBtn: true,
    textData: [
      {
        label: 'Aftersale No. ',
        value: DETAIL.sn,
        showCopy: true
      },
      {
        label: !isExchange ? 'Refund Amount' : '',
        value: common.parsePrice(applyInfo.refund_amount || 0)
      },
      {
        label: applyInfo.reason_title ? 'Reason' : '',
        value: applyInfo.reason_title
      },
      {
        label: 'Time',
        value: common.tiemstap(DETAIL.created_at * 1000)
      }
    ]
  }
  const exchangeMap = {
    label: exchangeInfo.id ? 'Exchange' : '',
    value: exchangeInfo?.sku_map?.join(',')
  }
  applicationData.textData.splice(1, 0, exchangeMap)
  // 商品信息展示是每个详情页默认会展示的
  detailCardData.value.push(applicationData)

  let serviceType = ''
  // type  售后类型1 退款退货 2 退款 3 维修 4 换货
  switch (applyInfo.provide_type) {
    case '1':
      serviceType = 'Return & Refund'
      break
    case '2':
      serviceType = 'Refund'
      break
    case '3':
      // serviceType = 'Exchange'
      break
    case '4':
      serviceType = 'Exchange'
      break
    default:
      break
  }
  pageTitle.value = serviceType

  detailCardData.value.unshift({
    title: 'Aftersale Log Information',
    status: 'log info',
    isCell: true
  })
  if (DETAIL.refund) {
    // 退款信息模块
    let returnTextData = [
      {
        label: 'Refund Order Amount',
        value: common.parsePrice(DETAIL.refund.refund_order_amount)
      },
      {
          label: 'Refund Shipping Fee',
          value: common.parsePrice(DETAIL.refund.refund_shipping_fee),
      },
      {
        label: 'Refund Time',
        value: common.tiemstap(DETAIL.refund.updated_at * 1000)
      },
      {
        label: DETAIL.refund.channel ? 'Refund Channel' : '',
        value: DETAIL.refund.channel
      },
       {
          label: DETAIL.refund.refund_account ?  'Refund Account' : '',
          value: DETAIL.refund.refund_account,
      },
    ]
    // 我的申请信息模块,每个详情页固定的模块
    detailCardData.value.unshift({
      title: 'Refund Total Amount',
      status: 'return info',
      textData: returnTextData,
      showAmount: true,
      amount: common.parsePrice(DETAIL.refund.refund_amount),
      isRight: true
    })
    logisticsData.value = {}
  } else {
    DETAIL?.transit?.express_sn && getLogistics(DETAIL?.transit?.express_sn)
  }

  // 按钮出现顺序进行排序
  let btnArr: any = []
  if (DETAIL.available_action.some((item: any) => item == 4)) {
    btnArr = [4].concat(
      DETAIL.available_action.filter((items: any) => items != 4)
    )
  } else {
    btnArr = [].concat(DETAIL.available_action)
  }

  DETAIL.available_action = btnArr
  // 处理显示的按钮 例如确认取消等
  DETAIL.available_action.forEach((item: number) => {
    if (item === 4) {
      btnData.value.push({
        plain: true,
        textColor: '#333333',
        bordersColor: '#999999',
        radiusSize: '20px',
        title: 'Cancel',
        status: item
      })
    } else if (item === 3) {
      btnJurisdictionObj.value.isAvailable = true
      btnData.value.push({
        plain: true,
        textColor: '#333333',
        bordersColor: '#999999',
        radiusSize: '20px',
        title: 'Appeal',
        status: item
      })
    } else if (item === 1) {
      if (DETAIL.available_type === 1 || DETAIL.available_type === 4) {
        btnData.value.push({
          plain: true,
          textColor: '#E04545',
          bordersColor: '#E04545',
          radiusSize: '20px',
          title: 'Confirm',
          status: item,
          available_type: DETAIL.available_type
        })
      } else if (DETAIL.available_type === 5) {
        btnData.value.push({
          plain: true,
          textColor: '#E04545',
          bordersColor: '#E04545',
          radiusSize: '20px',
          title: 'Return',
          status: item,
          available_type: DETAIL.available_type
        })
      }
    }
  })

  // 评论按钮
  if (DETAIL.comment_status == 0 && DETAIL.status == 3) {
    btnData.value.push({
      plain: true,
      textColor: '#E04545',
      bordersColor: '#E04545',
      radiusSize: '20px',
      title: 'Review'
    })
  }
}
const getLogistics = async (num: number) => {
  let parama = {
    bizOrderNo: num,
    langType: 'en',
    identity: 1
  }
  // this.$indicator.open()
  let res = await $http.getLogistics(parama).finally(() => {
    // this.$indicator.close()
  })
  if (res.code === 200) {
    logisticsData.value = {...res.data,express_sn: num}
    res.data.waybillList.forEach((item: any) => {
      waybill.value = item.nodeInfos.find(
        (item2: any) => item2?.trackingInfo.length
      )
    })
  } else {
    Toast({
      message: res.message || res.error,
      duration: 3000
    })
  }
}
// 查看物流轨迹
const handleLogistics = () => {
  router.push(`/logistics/${logisticsData.value.express_sn}`)
}
getAfterSaleDetail()

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      title: `${_unref(pageTitle)} Details`,
      backgroundColor: "#FFFFFF",
      fontColor: "#303133",
      skipPath: _unref(skipPath),
      ios_app: true
    }, {
      right: _withCtx(() => [
        _createElementVNode("div", {
          class: "header-right",
          onClick: goToRule
        }, [
          _createVNode(_component_van_icon, {
            name: "question-o",
            size: "0.5rem"
          }),
          _hoisted_2
        ])
      ]),
      _: 1
    }, 8, ["title", "skipPath"]),
    _createElementVNode("div", {
      class: "after-sale-details-tip",
      onClick: jumpShop
    }, [
      _hoisted_3,
      _createElementVNode("u", _hoisted_4, _toDisplayString(_unref(storeName)), 1),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_van_steps, {
          active: _unref(topData).active,
          "finish-icon": "success",
          "icon-size": "20px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", null, _toDisplayString(_unref(topData).afterSaleStatus), 1),
            (_unref(topData).time > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _createVNode(_component_van_count_down, {
                    time: 1000 * _unref(topData).time,
                    format: "DDd HH:mm:ss"
                  }, null, 8, ["time"])
                ]))
              : _createCommentVNode("", true),
            (_unref(topData).textData?.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(topData).textData, (valueItem, inx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "service_text",
                    key: inx
                  }, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(valueItem?.title_en) + ": ", 1),
                    _createElementVNode("span", null, _toDisplayString(valueItem?.value), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (_unref(topData).fileList?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topData).fileList, (file) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_component_van_image, {
                        width: "1.38rem",
                        height: "1.38rem",
                        src: file.content,
                        fit: "cover"
                      }, null, 8, ["src"])
                    ]))
                  }), 256))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_unref(waybill)?.trackingInfo?.length)
            ? (_openBlock(), _createBlock(_component_van_cell, {
                key: 0,
                class: "return-tracking",
                center: "",
                "is-link": "",
                onClick: handleLogistics
              }, {
                title: _withCtx(() => [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", null, _toDisplayString(_unref(waybill)?.trackingInfo[0]?.tracking), 1),
                    _createElementVNode("p", null, _toDisplayString(dateFormat(_unref(waybill)?.trackingInfo[0]?.trackingTime * 1000)), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(DetailCardNew, {
            detailData: _unref(detailCardData),
            onContactClick: handleContact,
            onLogInfo: clickLogInfo
          }, null, 8, ["detailData"])
        ])
      ])
    ]),
    (_unref(btnData).length)
      ? (_openBlock(), _createBlock(BottomBtn, {
          key: 0,
          onClick: handleBtn,
          btnData: _unref(btnData)
        }, null, 8, ["btnData"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      show: _unref(showDialog),
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : showDialog = $event)),
      class: "after-dialog",
      closeable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(popupValue)), 1),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(KiliButton, {
            plain: "",
            textColor: "#666666",
            bordersColor: "#99999",
            title: "Contact Seller",
            onClick: handleContact
          }),
          _createVNode(KiliButton, {
            textColor: "#E04545",
            bordersColor: "#E04545",
            title: "Continue",
            loading: _unref(loading),
            onClick: handleContinue
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})